import { Data } from "@angular/router";
import { Component, OnInit, Input, Inject } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { NotificationsService } from "angular2-notifications";
import { trigger, transition, style, animate } from "@angular/animations";
import { InterpretationService } from "../../../../modules/interpretation/interpretation.service";
import { FileReaderEvent } from "../../../../shared/models/FileReader";
import { EditPhotoComponent } from "../../../../shared/components/edit-photo/edit-photo.component";
import { UserService } from "../../../../shared/services/user.service";
import { PopupEndPoint } from "../../../../modules/inspection/models/create-inspection.model";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
} from "@angular/material/dialog";
import { SetupImplementService } from "../../../../modules/GET_NEW_UI/setup-implement/setup-implement.service";
import { Subscription } from "rxjs/Subscription";
import { heicTo } from "heic-to";
import { EqualiserBarImages } from "../../../../entities/setup/model";
import { AddThermalPhotoModel } from "../../../../modules/interpretation/models/interpretation.model";

@Component({
  selector: "app-view-photo-component",
  templateUrl: "./view-photo-component.html",
  styleUrls: ["./view-photo-component.scss"],
  animations: [
    trigger("fadeIn", [
      transition(":enter", [
        style({ opacity: 0 }),
        animate("500ms", style({ opacity: 1 })),
      ]),
    ]),
  ],
})
export class ViewPhotoComponentComponent implements OnInit {
  //conditionType: Condition;
  photoId: number;
  photoLoading = true;
  photo: string;
  private reloadPhoto = false;
  isInspector = false;
  isInterpreter = false;
  equipmentId: number;
  isedit: boolean = true;
  photoType: string;
  equipmentid: number;
  img: string;
  imageUrl: string;
  isImageUrl: boolean = false;
  isManuallyClosed: boolean = false;
  private _subscriptions: Subscription[] = [];
  imagePath: string;
  imageData: EqualiserBarImages;
  comingFrom: PopupEndPoint;
  inspectionId: number;
  showEditOrReplace: boolean = false;

  constructor(
    private _dialogRef: MatDialogRef<ViewPhotoComponentComponent>,
    @Inject(MAT_DIALOG_DATA) private _data: any,
    private _sanitizer: DomSanitizer,
    private _notify: NotificationsService,
    private _interp: InterpretationService,
    private _editPhotoDialog: MatDialog,
    private _user: UserService,
    private _implementService: SetupImplementService,
  ) {}

  ngOnInit() {
    this.checkPermissions();
    this.comingFrom = this._data.comingFrom;
    if( this.comingFrom == PopupEndPoint.InterpretationComponent)
        this.showEditOrReplace = true;
    this.imageData = this._data.Data;
    this.inspectionId = this._data.inspectionId;
    this.assignPhotoData(this.sanitize(this.imageData));
    this.isImageUrl = true;
  }

  checkPermissions() {
    this._user.getUserJobRoles().subscribe(
      (jobRoles) => {
        jobRoles.forEach((role) => {
          switch (role.Name) {
            case "Inspectors":
              this.isInspector = true;
              break;
            case "Interpreters":
            case "Super User":
            case "Administrator":
              this.isInterpreter = true;
              this.isInspector = true;
              break;
            case "Customer Admin":
              this.isInspector = true;
              this.isInterpreter = true;
              break;
          }
        });
      },
      (error) => {
        console.error(error);
        this._notify.error("Error", "Unable to check your job roles. ");
      },
    );
  }

  editPhoto() {
    this._interp.getBase64Image(this.photo).subscribe({
      next: (res: string) => {
        const base64Image = "data:image/png;base64," + res;
        this.openEditModal(base64Image);
      },
      error: (err) => {
        console.error("Error converting image:", err);
        this._notify?.error?.("Error", "Unable to load image for editing.");
      },
    });
  }

  openEditModal(base64Image: string) {
    const editPhotoModalRef = this._editPhotoDialog.open(EditPhotoComponent, {
      data: { photoWithExt: base64Image },
    });
    editPhotoModalRef.afterClosed().subscribe((res) => {
      if (res != null) {
        this.photo = res.photo;
        this.updatePhoto(res.photo);
      }
    });
  }

  assignPhotoData(data: string) {
    this.photo = data;
    this.photoLoading = false;
  }

  errorMessage(error: any) {
    console.error(error);
    this._notify.error(
      "Error",
      "Unable to load the photo. Please contact TrackTreads support. ",
    );
  }

    sanitize(image: EqualiserBarImages): string {
      if (image?.ImagePath?.startsWith('https://')) {
        return image.ImagePath;
      }
      if ((image as any)?.ImageUrl?.startsWith('https://')) {
        return (image as any).ImageUrl;
      }
      return '';
    }

  deletePhotoSuccess(title: string, message: string) {
    this._notify.success(title, message);
    this.reloadPhoto = true;
    this.photoLoading = false;
    console.log("isImageUrl", this.isImageUrl);
    this._dialogRef.close({ removed: true });
  }

  updatePhotoError(title: string, message: string) {
    this._notify.error(title, message);
    console.error(message);
    this.photoLoading = false;
  }

  deletePhoto() {
    if (this.comingFrom) {
      switch (this.comingFrom) {
        case PopupEndPoint.InterpretationComponent:
          this._interp
            .deleteEqBarInspPhoto(this.inspectionId, this.imageData.ImageId)
            .subscribe(
              (p) => {
                if (p.m_Item1) {
                  this.deletePhotoSuccess("Deleted", p.m_Item2);
                } else {
                  this.updatePhotoError(
                    "Failed",
                    "Unable to delete the photo. Please contact TrackTreads support. ",
                  );
                }
              },
              (err) => {
                this.updatePhotoError(
                  "Failed",
                  "Unable to delete the photo. Please contact TrackTreads support.",
                );
              },
            );
        break;
        case PopupEndPoint.AddNewInspectionComponent: 
        case PopupEndPoint.CreateEditInspectionComponent:
            //this.imageData.IsDeleted = true;
            this._notify.success('Deleted', 'Photo deleted successfully.');
            this._dialogRef.close({
                action: 'delete',
                image: this.imageData
            });
        break;
      }
    }
  }

  updatePhotoSuccess(title: string, message: string) {
    this._notify.success(title, message);
    this.reloadPhoto = true;
  }

  updatePhoto(newPhoto: string) {
    this.photoLoading = true;
    const photo = new AddThermalPhotoModel();
    photo.InspectionId = this.inspectionId;
    photo.PhotoId = this.imageData.ImageId;
    photo.NewPhoto = newPhoto;
    if (this.comingFrom) {
      switch (this.comingFrom) {
        case PopupEndPoint.InterpretationComponent:
          this._interp.updateEqBarInspPhoto(photo).subscribe(
            (p) => {
              if (p.m_Item1) {
                this.updatePhotoSuccess("Updated", p.m_Item2);
                this.imageData.ImagePath = p.m_Item3;
                this.assignPhotoData(this.sanitize(this.imageData));
              } else {
                this.updatePhotoError("Failed", p.m_Item2);
              }
              this.photoLoading = false;
            },
            (err) => {
              this.photoLoading = false;
              this.updatePhotoError(
                "Failed",
                "Unable to update the photo. Please contact TrackTreads support.",
              );
            },
          );
        break;
        case PopupEndPoint.AddNewInspectionComponent:
        case PopupEndPoint.CreateEditInspectionComponent:
            this.imageData.ImagePath = newPhoto;
            this.imageData.IsDeleted = false;
            this._notify.success('Updated', 'Photo updated successfully.');
            this._dialogRef.close({
                action: 'update',
                image: this.imageData
            });
        break;
      }
    }
  }

  compressImage(src) {
    return new Promise((res, rej) => {
      const img = new Image();
      img.src = src;
      img.onload = () => {
        const elem = document.createElement("canvas");
        let width, height;
        width = img.width;
        height = img.height;
        console.log("width", width);
        console.log("height", height);
        var ratio = height / width; //cal aspect ratio
        let imageWidth = 800; //643
        var new_height = imageWidth * ratio; //calculate new height
        elem.width = imageWidth;
        elem.height = new_height;
        const ctx = elem.getContext("2d");
        ctx.drawImage(img, 0, 0, imageWidth, new_height);
        const data = ctx.canvas.toDataURL();
        res(data);
      };
      img.onerror = (error) => rej(error);
    });
  }

  async replacePhotoClicked(event: any) {
    if (!(event.target.files && event.target.files[0])) {
      return;
    }
    this.photoLoading = true;
    const file = event.target.files[0];
    const extension = file.name.split(".").pop()?.toLowerCase();
    const mimeType = (file.type || "").toLowerCase();
    const isHeic =
      extension === "heic" ||
      extension === "heif" ||
      mimeType.includes("heic") ||
      mimeType.includes("heif");

    const processFile = (f: File) => {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const imageUrl = e.target.result;
        this.compressImage(imageUrl)
          .then((res: string) => {
            if (res) {
              this.updatePhoto(res.split(",")[1]);
            }
          })
          .catch(() => {
            this.photoLoading = false;
          });
      };
      reader.readAsDataURL(f);
    };
    try {
      if (isHeic) {
        const convertedBlob = await heicTo({
          blob: file,
          type: "image/jpeg", // Use "toType" if your installed version requires it
          quality: 0.8,
        });
        const convertedFile = new File(
          [convertedBlob as Blob],
          "converted.jpg",
          {
            type: "image/jpeg",
          },
        );
        processFile(convertedFile);
      } else {
        processFile(file);
      }
    } catch (err: any) {
      this.photoLoading = false;
      console.error("HEIC conversion failed", err);
      this.updatePhotoError(
        "Failed",
        "Unable to process this HEIC image. Please convert it to JPG and try again.",
      );
    }
    event.target.value = null;
  }

  openLargeImage(base64Data: string): void {
    const imageBase64 = this.isImageUrl
      ? base64Data
      : `data:image/jpeg;base64,${base64Data}`;

    const width = window.screen.availWidth;
    const height = window.screen.availHeight;

    const newWindow = window.open(
      "",
      "_blank",
      `toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=yes,width=${width},height=${height},top=0,left=0`,
    );

    if (!newWindow) {
      alert("Popup blocked. Please allow popups for this website.");
      return;
    }

    newWindow.document.write(`
<!DOCTYPE html>
<html>
<head>
<title>Image Viewer</title>

<style>

html,body{
    margin:0;
    width:100%;
    height:100%;
    overflow:hidden;
    background:#000;
    font-family:Arial,Helvetica,sans-serif;
}

.toolbar{
    position:fixed;
    top:12px;
    left:50%;
    transform:translateX(-50%);
    display:flex;
    align-items:center;
    justify-content:space-between;
    min-width:430px;
    padding:6px 8px;
    background:rgba(35,35,35,.92);
    border-radius:8px;
    box-shadow:0 4px 15px rgba(0,0,0,.45);
    z-index:9999;
}

.toolbar-left{
    display:flex;
    align-items:center;
    gap:6px;
}
.toolbar button{
    height:30px;
    min-width:30px;
    border:none;
    border-radius:4px;
    background:#1976d2;
    color:#fff;
    font-size:14px;
    font-weight:600;
    cursor:pointer;
    padding:0 8px;
    transition:.2s;
}

.toolbar button:hover{
    background:#1565c0;
}

.zoomText{
    color:#fff;
    min-width:46px;
    text-align:center;
    font-size:14px;
    font-weight:600;
}

.fit-btn{
    min-width:82px;
}

.close-btn{
    margin-left:12px;
    width:30px !important;
    min-width:30px !important;
    height:30px;
    padding:0 !important;
    background:#d32f2f !important;
    font-size:18px !important;
    font-weight:bold;
    line-height:30px;
}

.close-btn:hover{
    background:#b71c1c !important;
}

.viewer{
    width:100%;
    height:100%;
    display:flex;
    justify-content:center;
    align-items:center;
    overflow:hidden;
    cursor:grab;
}

.viewer:active{
    cursor:grabbing;
}

img{
    user-select:none;
    -webkit-user-drag:none;
    transform-origin:center center;
    transition:transform .08s linear;
    max-width:none;
    max-height:none;
}

</style>

</head>

<body>

<div class="toolbar">
    <div class="toolbar-left">
        <button id="zoomOut" title="Zoom Out">−</button>

        <span id="zoomValue" class="zoomText">125%</span>

        <button id="zoomIn" title="Zoom In">+</button>

        <button id="reset" title="Reset Zoom">125%</button>

        <button id="fit" class="fit-btn">Screen Fit</button>
    </div>

    <button class="close-btn" title="Close" onclick="window.close()">
        &#10005;
    </button>
</div>

<div class="viewer" id="viewer">
    <img id="img" src="${imageBase64}" draggable="false"/>
</div>

<script>

const img=document.getElementById('img');
const viewer=document.getElementById('viewer');
const zoomText=document.getElementById('zoomValue');

let scale=1.25;
let posX=0;
let posY=0;
let isDragging=false;
let startX=0;
let startY=0;

function updateImage(){

    img.style.transform =
        'translate(' + posX + 'px,' + posY + 'px) scale(' + scale + ')';

    zoomText.innerText = Math.round(scale * 100) + '%';

    viewer.style.cursor = canDrag() ? 'grab' : 'default';
}

updateImage();

document.getElementById('zoomIn').onclick=function(){
    scale = Math.min(scale + 0.1, 5);
    updateImage();
};

document.getElementById('zoomOut').onclick=function(){
    if(scale>0.2){
        scale = Math.max(scale - 0.1, 0.2);
        updateImage();
    }
};

document.getElementById('reset').onclick=function(){
    scale = 1.25;
    posX=0;
    posY=0;
    updateImage();
};

document.getElementById('fit').onclick=function(){

    const vw=viewer.clientWidth;
    const vh=viewer.clientHeight;

    const iw=img.naturalWidth;
    const ih=img.naturalHeight;

    scale = Math.min(vw / iw, vh / ih) * 0.95;

    posX=0;
    posY=0;

    updateImage();
};

function canDrag() {
    return true;
}

viewer.addEventListener('wheel',function(e){

    e.preventDefault();

    if(e.deltaY<0)
        scale+=0.1;
    else if(scale>0.2)
        scale-=0.1;

    updateImage();

},{passive:false});

viewer.addEventListener('mousedown', function (e) {

    if (!canDrag()) return;

    isDragging = true;

    startX = e.clientX - posX;
    startY = e.clientY - posY;

    viewer.style.cursor = 'grabbing';

    e.preventDefault();

});

window.addEventListener('mousemove',function(e){

    if(!isDragging) return;

    posX=e.clientX-startX;
    posY=e.clientY-startY;

    updateImage();

});

window.addEventListener('mouseup', function () {

    isDragging = false;

    viewer.style.cursor = canDrag() ? 'grab' : 'default';

});

</script>

</body>

</html>
`);

    newWindow.document.close();
    newWindow.focus();

    newWindow.moveTo(0, 0);
    newWindow.resizeTo(width, height);
  }
}
